<template>
  <v-container fluid class="ma-0 pa-0">
    <v-dialog
      v-model="dialog"
      scrollable
      :overlay="false"
      max-width="80vw"
      transition="dialog-transition"
    >
      <contact-detail
        ref="detail"
        :wholesaler="selected"
        @saved="onSaved"
        @closed="dialog = false"
      ></contact-detail>
    </v-dialog>
    <ag-grid-vue
      v-if="rowData"
      style="width: 100%; height: 15vh"
      class="ag-theme-balham mb-4"
      @grid-ready="onGridReady"
      @rowSelected="getSelectedRows()"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      rowSelection="single"
      :rowData="rowData"
    ></ag-grid-vue>
  </v-container>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import { HTTP } from "@/http-common";
import contactDetail from "@/components/wholesaler/ContactDetail";
export default {
  name: "WholesalerContact",
  components: {
    AgGridVue,
    contactDetail,
  },

  data() {
    return {
      dialog: false,
      gridOptions: null,
      columnDefs: null,
      defaultColDef: {
        resizable: true,
      },
      gridApi: null,
      rowData: [],
      selected: {},
    };
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.columnDefs = [
      {
        headerName: "WholesalerName",
        field: "wholesaleName",
        sortable: true,
        filter: true,
      },

      {
        headerName: "Email",
        field: "email",
        sortable: true,
        filter: true,
      },
      {
        headerName: "Bcc",
        field: "bcc",
        sortable: true,
        filter: true,
      },
    ];
  },
  methods: {
    getData() {
      let vm = this;

      HTTP.get("oms/ListDataUsageContacts").then((data) => {
        vm.rowData = data.data;
      });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.getData();

      this.gridApi.sizeColumnsToFit();
    },
    getSelectedRows(params) {
      let vm = this;
      const selectedData = vm.gridApi.getSelectedRows();
      vm.selected = selectedData[0];
      this.dialog = true;
      vm.$refs.detail.tempValue = vm.selected;
    },
    onSaved(val) {
      this.dialog = false;
      this.getData();
    },
  },
};
</script>

<style scoped>
</style>